/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../../services'

 
export const getAllOrgApplicationAuthProviders = createAsyncThunk('org/getAllOrgApplicationAuthProviders', async (_, { rejectWithValue }) => {
    try { 
        const data = await api.orgAppAuthProvider
        .getAllOrgApplicationAuthProviders()
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getAllOrgsAppsAuthProvidersByOrgID = createAsyncThunk('org/getAllOrgsAppsAuthProvidersByOrgID', async (orgId, { rejectWithValue }) => {
    try { 
        const data = await api.orgAppAuthProvider
        .getAllOrgsAppsAuthProvidersByOrgID(orgId)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getOrgAppAuthProviderHistory = createAsyncThunk('org/getOrgAppAuthProviderHistory', async (params, { rejectWithValue }) => {
    try { 
        const data = await api.orgAppAuthProvider.getOrgAppAuthProviderHistory(params)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
